module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-background"
  }, [_c('div', {
    staticClass: "video-foreground"
  }, [_c('video', {
    ref: "test",
    attrs: {
      "controls": "",
      "src": require("../assets/sarikayasahinVideo.mp4"),
      "width": _vm.width,
      "height": _vm.height,
      "videoWidth": _vm.width,
      "videoHeight": _vm.height,
      "autoplay": "",
      "muted": ""
    },
    domProps: {
      "muted": true
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "videoOverlay"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ed828b3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/videoBg.vue
// module id = 116
// module chunks = 0